import { cn } from '@ethena/shared-ui/utils'
import Image from 'next/image'

export const InfoBox = ({
  description,
  image,
  size = 'small',
  title,
}: {
  image: string
  title: string
  description: string
  size?: 'small' | 'large'
}) => {
  return (
    <div className="flex flex-col">
      <Image src={image} alt={title} width={24} height={24} className="h-6 w-6 mb-5" />
      <h3 className={cn('text-text-primary font-medium mb-3', size === 'large' ? 'text-2xl' : 'text-lg')}>{title}</h3>
      <p className="text-text-muted text-base font-inter">{description}</p>
    </div>
  )
}
